import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
  CSSReset,
  ThemeProvider
} from '@chakra-ui/core'
import { css, Global } from '@emotion/core'
import Amplify from 'aws-amplify'
import React from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import * as ReactDOM from 'react-dom'
import client from './apollo'
import awsExports from './aws-exports'
import { FallbackErrorMessage } from './components'
import { BUGSNAG_API_KEY } from './constants'
import { AppProvider } from './contexts'
import App from './App'
import { register, unregister } from './serviceWorker'
import { theme } from './theme'

const bugsnagClient = bugsnag(BUGSNAG_API_KEY)
bugsnagClient.use(bugsnagReact, React)
const ErrorBoundary = bugsnagClient.getPlugin('react')

/**
 * Amplify setup - for login only
 */
Amplify.configure(awsExports)

/**
 * Setup React Axe for accessibility
 */
// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('react-axe')
//   axe(React as any, ReactDOM, 1000)
// }

ReactDOM.render(
  <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={client}>
        <AppProvider>
          <CSSReset />
          <Global
            styles={css`
              html {
                font-family: ${theme.fonts.body};
              }
            `}
          />
          <App />
        </AppProvider>
      </ApolloProvider>
    </ThemeProvider>
  </ErrorBoundary>,
  document.getElementById('root') as HTMLElement
)

if (process.env.REACT_APP_UNREGISTER_SERVICE_WORKER) {
  unregister()
} else {
  register({
    onUpdate: () =>
      function RegisterWorker() {
        return (
          <Alert status="info">
            <AlertIcon />
            <AlertTitle mr={2}>A new version is available!</AlertTitle>
            <AlertDescription>Please refresh your browser to get it.</AlertDescription>
            <CloseButton position="absolute" right="8px" top="8px" />
          </Alert>
        )
      }
  })
}
